export const Sales = [
    {
      policy_number: 10000,
      policy_type: "Auto",
      premium: 371,
      result: "CC",
      reason: null,
      contactDate: "2022-04-26", 
      effectiveDate: "2022-04-30"
    },
    {
        policy_number: 10001,
        policy_type: "Home",
        premium: 2176,
        result: "CC",
        reason: null,
        contactDate: "2022-02-05", 
        effectiveDate: "2022-02-25"
      },
      {
        policy_number: 10002,
        policy_type: "Auto",
        premium: 456,
        result: "CC",
        reason: null,
        contactDate: "2022-04-19", 
        effectiveDate: "2022-04-29"
      },
      {
        policy_number: 10003,
        policy_type: "Auto",
        premium: 938,
        result: "CC",
        reason: null,
        contactDate: "2022-05-01", 
        effectiveDate: "2022-05-20"
      },
      {
        policy_number: 10004,
        policy_type: "Auto",
        premium: 976,
        result: "CC",
        reason: null,
        contactDate: "2020-11-01", 
        effectiveDate: "2021-11-20"
      },
      {
        policy_number: 10005,
        policy_type: "Auto",
        premium: 976,
        result: "CC",
        reason: null,
        contactDate: "09-24-2022", 
        effectiveDate: "2022-07-07"
      },
      {
        policy_number: 10006,
        policy_type: "Auto",
        premium: 421,
        result: "DCL",
        reason: null,
        contactDate: "09-24-2022", 
        effectiveDate: "2022-07-07"
      },
      {
        policy_number: 10007,
        policy_type: "Auto",
        premium: 389,
        result: "INC",
        reason: null,
        contactDate: "09-24-2022", 
        effectiveDate: "2022-07-07"
      },
  ];
  